module.exports = __webpack_public_path__ + "img/red_logo.657fbf40.png";